import { handleGestureChange } from "./handleGestureChange";
import { EventToCanvas } from "./EventToCanvas";
import { prepHandleEvent } from "./prepHandleEvent";
import { Globals } from "../CoreApp/Globals";
export function handleTouchMove(event) {
  // in android, we send multi touch events to our gesture event functions for pinch zoom
  if (event.touches.length == 2) {
    handleGestureChange(event);
  } else if (event.changedTouches.length == 1 && !Globals._gestureActive) {
    var theTouch = event.changedTouches[0];
    var x = theTouch.clientX;
    var y = theTouch.clientY;
    var canvas = document.getElementById("basecanvas");
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas({ clientX: x, clientY: y }, rect.left, rect.top);

    var myApp = prepHandleEvent(this, true, p.x, p.y);
    if (myApp == null) return;

    myApp.HandleMouseMove(p.x, p.y);
  }
}
